import styled from 'styled-components';
import { backgroundColors, colors, smallShadow, spacing } from 'ui/theme';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { FullWidth } from 'ui/utility/fullWidth';
import { pxToRem } from 'utils/convert';

export const Background = styled(FullWidth)`
  padding-top: ${spacing.double};
  padding-bottom: ${spacing.double};
  background-color: ${backgroundColors.backgroundSecondary};
`;

export const PageContent = styled(FixedWidth)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const PageWrapper = styled.div`
  padding-bottom: ${spacing.double};
  margin: 0 auto;
  max-width: ${pxToRem(1216)};
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${spacing.double};
  padding-top: ${spacing.double};
  padding-bottom: ${spacing.double};

  @media (min-width: 1024px) {
    grid-template-columns: ${pxToRem(320)} 1fr;
  }
`;

// Base card styles for Metrics and Payments cards
export const Card = styled.div`
  width: 100%;
  background-color: ${colors.white};
  border-radius: ${spacing.half};
  ${smallShadow}
  
  & + & {
    margin-top: ${spacing.double};
  }
`;

export const LeftContent = styled.div``;

export const RightContent = styled.div``;
